/** Frontmatter for the "week6-start-sit-darkness-report" article; the Body lives in week6-start-sit-darkness-report.jsx. */
const meta = {
  slug: 'week6-start-sit-darkness-report',
  title: 'Week 6 Start/Sit: The Darkness Report',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'All 14 games from Thursday night through Monday night, with Houston at Jacksonville in London at 9:30am ET, one card each: start, flex and sit calls, game-time decision callouts, a slate board of lines and implied points, an injury board with inactive windows, a handcuff board, D/ST and IDP streamers, position tiers, the Darkness Rulings and the inactives checklist.',
  readMinutes: 42,
  date: '2026-10-15',
};

export default meta;
